/**
 * The LpHeroFullsize component
 */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Container, Col, Row } from "reactstrap";
import Perks from "../../../components/Perks";
import CMSBlock from "../../../components/CMSBlock";
import { Link } from "react-router-dom";
import ResponsivePicture from "../../ResponsivePicture";
import FormattedNumber from "../../FormattedNumber";
import EditorFormHelpers from "../../FileUploadEditorForm/utils/FileUploadEditorFormHelpers";
import { FILEEDITOR } from "../../FileUploadEditorForm/utils/fileEditor";
import {
  Input,
  Label,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import ShopProductCard from "../../../components/ShopProductCard";

// FIXME enforce CMSBlockTeaser Layout
import CMSBlockTeaser from "../../../components/CMSBlock/utils/CMSBlockTeaser";

/**
 * Stateless react component to render the LpHeroFullsize component
 * @param {Object} props the props passed to the page.
 */
const LpHeroFullsize = (props, context) => {
  const {
    landingpage,
    productTeasers,
    cmsBlock1,
    cmsBlock2,
    cmsBlock3,
    presetFromUrl,
    language,
    navigateTo,
  } = props;

  const widgetConfiguration = JSON.parse(landingpage.widget_configuration);
  const widgetAvailableOptions = widgetConfiguration.availableOptions || {};
  let lp = {};
  if (widgetConfiguration) {
    lp.products = widgetConfiguration ? widgetConfiguration.products : false;
    lp.categories = widgetConfiguration
      ? widgetConfiguration.categories
      : false;
    lp.category_style = widgetConfiguration
      ? widgetConfiguration.category_style
      : "topbar";
  }
  // TODO set default from URL
  const [selectedSize, setSelectedSize] = useState([
    parseInt(
      presetFromUrl.get("width") ||
        (widgetAvailableOptions.availableSizes
          ? widgetAvailableOptions.availableSizes.sizes[0][0]
          : 50)
    ),
    parseInt(
      presetFromUrl.get("height") ||
        (widgetAvailableOptions.availableSizes
          ? widgetAvailableOptions.availableSizes.sizes[0][1]
          : 50)
    ),
  ]);
  const [selectedAmount, setSelectedAmount] = useState(
    parseInt(
      presetFromUrl.get("amount") ||
        (widgetAvailableOptions.availableAmounts
          ? widgetAvailableOptions.availableAmounts.amounts[0]
          : 1)
    )
  );

  const handleWidthChange = (e) => {
    e.preventDefault();
    const newSize = parseInt(e.target.value.replace(/[^\d]+/g, ""));
    setSelectedSize([newSize, selectedSize[1]]);
  };
  const handleHeightChange = (e) => {
    e.preventDefault();
    const newSize = parseInt(e.target.value.replace(/[^\d]+/g, ""));
    setSelectedSize([selectedSize[0], newSize]);
  };

  const widgetLink = () => {
    let link = `/${landingpage.language}/${landingpage.cta_link}/?`;
    if (widgetConfiguration.editorType)
      link += `product=${widgetConfiguration.editorType}&`;
    if (
      widgetAvailableOptions.availableSizes ||
      widgetAvailableOptions.customSize
    )
      link += `width=${selectedSize[0]}&height=${selectedSize[1]}&`;
    if (widgetAvailableOptions.availableAmounts)
      link += `amount=${selectedAmount}&`;
    return link.slice(0, -1);
  };

  const matchingVolumeDiscount = (amount) => {
    let currentDiscount = 0;
    if (
      FILEEDITOR[widgetConfiguration.editorType] &&
      FILEEDITOR[widgetConfiguration.editorType].discounts
    ) {
      FILEEDITOR[widgetConfiguration.editorType].discounts.forEach(
        (discount) => {
          if (discount.amount <= amount) {
            currentDiscount = discount.percentage;
          }
        }
      );
    }
    return currentDiscount;
  };

  return (
    <div className="lp-product-hero">
      <div className="hero container">
        <div className="hero__bg">
          <ResponsivePicture
            cover
            mediumData={{
              sources: landingpage.hero_image,
              metadata: {
                width: "100%",
                height: "100%",
              },
            }}
            altTitle={landingpage.title}
          />
        </div>
        <header className="hero__content-floating col-lg-5 col-md-12 bg-white mx-5 my-4 p-3 pull-right rounded shadow">
          {landingpage.title && <h1>{landingpage.title}</h1>}
          {landingpage.intro && (
            <div dangerouslySetInnerHTML={{ __html: landingpage.intro }} />
          )}
          {widgetAvailableOptions && (
            <Row>
              {widgetAvailableOptions.customSize && (
                <Col md={12}>
                  <strong>{context.t("select a size")}</strong>
                  <div className="d-flex flex-nowrap">
                    <div className="flex-grow-1">
                      <div className="form-group pr-1">
                        <Label>{context.t("Width")}</Label>
                        <InputGroup>
                          <Input
                            type="number"
                            value={selectedSize[0]}
                            className={
                              isNaN(selectedSize[0]) ||
                              parseInt(selectedSize[0]) < 10
                                ? "is-invalid"
                                : ""
                            }
                            onChange={handleWidthChange.bind(this)}
                            name="selectedSize[0]"
                            min={10}
                          ></Input>
                          <InputGroupAddon addonType="append">
                            <InputGroupText>mm</InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      </div>
                      <div className="flex-fill text-center pb-3 mt-n3">
                        {!isNaN(selectedSize[0]) && !!selectedSize[0] && (
                          <span className="text-remark">
                            <FormattedNumber
                              value={Math.round(selectedSize[0] * 100) / 100}
                              language={landingpage.language}
                              unit="mm"
                              decimals={1}
                            />
                            &nbsp;=&nbsp;
                            <FormattedNumber
                              value={Math.round(selectedSize[0] * 10) / 100}
                              language={landingpage.language}
                              unit="cm"
                              decimals={2}
                            />
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <div className="form-group pl-1">
                        <Label>{context.t("Height")}</Label>
                        <InputGroup>
                          <Input
                            type="number"
                            value={selectedSize[1]}
                            className={
                              isNaN(selectedSize[1]) ||
                              parseInt(selectedSize[1]) < 10
                                ? "is-invalid"
                                : ""
                            }
                            onChange={handleHeightChange.bind(this)}
                            name="selectedSize[1]"
                            min={10}
                          ></Input>
                          <InputGroupAddon addonType="append">
                            <InputGroupText>mm</InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>
                      </div>
                      <div className="flex-fill text-center pb-3 mt-n3">
                        {!isNaN(selectedSize[1]) && !!selectedSize[1] && (
                          <span className="text-remark">
                            <FormattedNumber
                              value={Math.round(selectedSize[1] * 100) / 100}
                              language={landingpage.language}
                              unit="mm"
                              decimals={1}
                            />
                            &nbsp;=&nbsp;
                            <FormattedNumber
                              value={Math.round(selectedSize[1] * 10) / 100}
                              language={landingpage.language}
                              unit="cm"
                              decimals={2}
                            />
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </Col>
              )}

              {widgetAvailableOptions.availableSizes && (
                <Col
                  md={widgetAvailableOptions.availableSizes.gridOverwrite || 6}
                >
                  <strong>{context.t("select a size")}</strong>
                  <ul className="sizeselect-list">
                    {widgetAvailableOptions.availableSizes.sizes.map(
                      (availableSize, index) => {
                        return (
                          <li
                            key={`sizeavailable-${index}`}
                            className={
                              availableSize[0] === selectedSize[0] &&
                              availableSize[1] === selectedSize[1]
                                ? "selected py-1"
                                : "py-1"
                            }
                            onClick={setSelectedSize.bind(this, availableSize)}
                          >
                            <Row>
                              <Col
                                xs={
                                  widgetAvailableOptions.availableSizes
                                    .previewPrice
                                    ? 8
                                    : 12
                                }
                              >
                                <FormattedNumber
                                  value={
                                    Math.round(availableSize[0] * 100) / 100
                                  }
                                  language={landingpage.language}
                                  unit="mm"
                                  decimals={0}
                                />
                                &nbsp;x&nbsp;
                                <FormattedNumber
                                  value={
                                    Math.round(availableSize[1] * 100) / 100
                                  }
                                  language={landingpage.language}
                                  unit="mm"
                                  decimals={0}
                                />
                                &nbsp;
                                {widgetAvailableOptions.availableSizes
                                  .previewCm && (
                                  <span className="text-remark">
                                    (
                                    <FormattedNumber
                                      value={
                                        Math.round(availableSize[0] * 100) /
                                        1000
                                      }
                                      language={landingpage.language}
                                      unit="cm"
                                      decimals={1}
                                    />
                                    &nbsp;x&nbsp;
                                    <FormattedNumber
                                      value={
                                        Math.round(availableSize[1] * 100) /
                                        1000
                                      }
                                      language={landingpage.language}
                                      unit="cm"
                                      decimals={1}
                                    />
                                    )
                                  </span>
                                )}
                              </Col>
                              {widgetAvailableOptions.availableSizes
                                .previewPrice && (
                                <>
                                  <Col
                                    xs={4}
                                    className="text-right text-success"
                                  >
                                    <FormattedNumber
                                      value={parseFloat(
                                        EditorFormHelpers.calculatePrice({
                                          ...widgetConfiguration,
                                          width: availableSize[0],
                                          height: availableSize[1],
                                          amount: selectedAmount,
                                        }).displayPrice *
                                          (widgetConfiguration.displayTotalPrice
                                            ? selectedAmount
                                            : 1)
                                      )}
                                      language={landingpage.language}
                                      unit="€"
                                      decimals={2}
                                    />
                                  </Col>
                                </>
                              )}
                            </Row>
                          </li>
                        );
                      }
                    )}
                    <li>
                      {landingpage.cta_title &&
                        landingpage.cta_link &&
                        !widgetAvailableOptions.availableSizes
                          .customSizeAvailable && (
                          <Link
                            to={`${widgetLink()}&preopenSizeSelection=true`}
                            className="semi-small"
                          >
                            {context.t("More Sizes")}
                          </Link>
                        )}
                      {landingpage.cta_title &&
                        landingpage.cta_link &&
                        widgetAvailableOptions.availableSizes
                          .customSizeAvailable && (
                          <Link to={widgetLink()}>
                            {context.t("or enter custom size here")}
                          </Link>
                        )}
                    </li>
                  </ul>
                </Col>
              )}

              {widgetAvailableOptions.availableAmounts && (
                <Col
                  md={
                    widgetAvailableOptions.availableAmounts.gridOverwrite || 6
                  }
                >
                  <strong>{context.t("select a quantity")}</strong>
                  <ul className="sizeselect-list">
                    {widgetAvailableOptions.availableAmounts.amounts.map(
                      (availableAmount, index) => {
                        return (
                          <li
                            key={`amountavailable-${index}`}
                            className={
                              availableAmount === selectedAmount
                                ? "selected py-1"
                                : "py-1"
                            }
                            onClick={setSelectedAmount.bind(
                              this,
                              availableAmount
                            )}
                          >
                            <Row className="no-gutters">
                              <Col
                                xs={
                                  widgetAvailableOptions.availableAmounts
                                    .previewPrice
                                    ? 3
                                    : 12
                                }
                              >
                                {availableAmount}
                              </Col>
                              {widgetAvailableOptions.availableAmounts
                                .previewPrice && (
                                <>
                                  <Col
                                    xs={4}
                                    className="semi-small text-right text-secondary"
                                  >
                                    <FormattedNumber
                                      value={parseFloat(
                                        EditorFormHelpers.calculatePrice({
                                          ...widgetConfiguration,
                                          width: selectedSize[0],
                                          height: selectedSize[1],
                                          amount: availableAmount,
                                        }).displayPrice *
                                          (widgetConfiguration.displayTotalPrice
                                            ? availableAmount
                                            : 1)
                                      )}
                                      language={landingpage.language}
                                      unit="€"
                                      decimals={2}
                                    />
                                  </Col>
                                  <Col
                                    xs={5}
                                    className="semi-small text-right text-success"
                                    style={{ minWidth: "3rem" }}
                                  >
                                    {matchingVolumeDiscount(availableAmount) >
                                      0 && (
                                      <>
                                        <FormattedNumber
                                          value={parseFloat(
                                            matchingVolumeDiscount(
                                              availableAmount
                                            )
                                          )}
                                          language={landingpage.language}
                                          unit="%"
                                          decimals={0}
                                        />{" "}
                                        {context.t("discount")}
                                      </>
                                    )}
                                  </Col>
                                </>
                              )}
                            </Row>
                          </li>
                        );
                      }
                    )}
                  </ul>
                </Col>
              )}
            </Row>
          )}
          <Row>
            <Col xs={4}>
              <span className="text-success h2">
                <strong>
                  <FormattedNumber
                    value={parseFloat(
                      EditorFormHelpers.calculatePrice({
                        ...widgetConfiguration,
                        width: selectedSize[0],
                        height: selectedSize[1],
                        amount: selectedAmount,
                      }).displayPrice *
                        (widgetConfiguration.displayTotalPrice
                          ? selectedAmount
                          : 1)
                    )}
                    language={landingpage.language}
                    unit="€"
                    decimals={2}
                  />
                </strong>
              </span>
              <br />
              <span className="text-remark">{context.t("incl. VAT")}</span>
            </Col>
            <Col xs={8}>
              {landingpage.cta_title &&
                landingpage.cta_link &&
                landingpage.cta_link.substr(0, 4) !== "http" && (
                  <Link
                    to={widgetLink()}
                    className="btn btn-primary btn-lg btn-block"
                  >
                    {landingpage.cta_title}
                  </Link>
                )}
            </Col>
            <Col xs={12}>
              <span className="text-remark">
                {!widgetConfiguration.displayTotalPrice && (
                  <>{context.t("price per item")}</>
                )}
                {widgetConfiguration.displayTotalPrice && (
                  <>
                    {context.t("price for {selectedAmount} pieces", {
                      selectedAmount: selectedAmount,
                    })}
                  </>
                )}
                &#160;-&#160;
                <a
                  href={`/${landingpage.language}/versandarten/`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {context.t("plus shipping")}
                </a>
              </span>
            </Col>
          </Row>
        </header>
      </div>
      <Container className="bg-light py-2" style={{ clear: "both" }}>
        <Row className="justify-content-md-center">
          {cmsBlock1 && cmsBlock1[0] && (
            <Col xl={3} md={12}>
              <CMSBlock cmsBlock={cmsBlock1[0]} />
            </Col>
          )}
          {cmsBlock2 && cmsBlock2[0] && (
            <Col xl={3} md={12}>
              <CMSBlock cmsBlock={cmsBlock2[0]} />
            </Col>
          )}
          {cmsBlock3 && cmsBlock3[0] && (
            <Col xl={3} md={12}>
              <CMSBlock cmsBlock={cmsBlock3[0]} />
            </Col>
          )}
        </Row>
      </Container>
      {lp.products &&
        lp.products.map((category) => (
          <Container className="my-5">
            <h3 className="h5">{category.title}</h3>
            <Row>
              {category.products &&
                category.products.map((product) => (
                  <Col xl={2} lg={4} xs={6} className="mb-3">
                    <ShopProductCard
                      product={product}
                      language={language}
                      navigateTo={navigateTo}
                    />
                  </Col>
                ))}
            </Row>
            {!!category.external && (
              <a href={category.external} className="pull-right">
                {context.t("view all products")}
              </a>
            )}
            {!category.external && category.id && (
              <Link
                to={`/${language}/c/${category.id}/`}
                className="pull-right"
              >
                {context.t("view all products")}
              </Link>
            )}
          </Container>
        ))}
      <Container className="my-5">
        {landingpage.subtitle && <h2>{landingpage.subtitle}</h2>}
        <Row>
          {productTeasers &&
            productTeasers.map((block) => (
              <Col xl={3} md={6} key={block.id}>
                <CMSBlockTeaser
                  key={`home_cms_block_${block.id}`}
                  cmsBlock={block}
                />
              </Col>
            ))}
        </Row>
      </Container>

      {landingpage.content && (
        <Container className="my-5">
          <div dangerouslySetInnerHTML={{ __html: landingpage.content }} />
        </Container>
      )}
      <Perks />
    </div>
  );
};

/** define proptypes for the form */
LpHeroFullsize.propTypes = {
  /** the item */
  landingpage: PropTypes.object.isRequired,
};

/**  define proptype for the 'translation' function  */
LpHeroFullsize.contextTypes = {
  t: PropTypes.func,
};
export default LpHeroFullsize;
